export default "__VITE_ASSET__4Ie6uLKf__"